<template>
  <div>
    <el-form-item label="弹出标题">
      <el-input v-model="data.placeholder"></el-input>
    </el-form-item>
    <el-form-item label="最大选择量">
      <el-input-number v-model="data.maxRows"  :min="1" :max="100" ></el-input-number>
    </el-form-item>
    <el-form-item label="是否只读">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
    <el-form-item label="请求地址">
      <el-input
      type="textarea"
      :rows="2"
      placeholder="请输入请求地址"
      v-model="data.endPlaceholder">
    </el-input>
    </el-form-item>
     <el-form-item label="用户id回填字段">
      <el-input v-model="data.callIdName"></el-input>
    </el-form-item>
    <el-form-item label="联动URL" label-width="100px" label-position="left">
        <el-input v-model="data.casUrl"></el-input>
    </el-form-item>
  </div>
</template>

<script>
import mixinIsDynamic from '../../mixins/isDynamic'
export default {
  mixins: [mixinIsDynamic],
  name: 'ConfigConfigFlowUserChoose',
  props: ['data', 'widgetForm'],
  data() {
    return {
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      }
    }
  },
  mounted() {
  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    }

  },
  watch: {
    'data.required': function(val) {
      if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
      else this.validator.required = null
      this.generateRule()
    }
  }
}
</script>
